<app-data-table
  [tableId]="'information-table'"
  [tableConfig]="tableConfig"
  [topOptions]="topOptions"
  [onClickRow]="onClickRow"
  [fetchTableData]="fetchData"
  [keepAppliedSearch]="true">
</app-data-table>